import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppFeatures, canIUse, getSetting, Settings } from '../../helpers/PermissionUtility';
import { permanentRedirect } from '../helpers';

/**
 * Handles the `/` route and redirects to various locations based on features enabled
 * in the app.
 */
export default function IndexRedirect(): React.ReactElement {
  const navigate = useNavigate();
  const redirect = permanentRedirect(navigate);

  useEffect(() => {
    if (canIUse(AppFeatures.Dashboard) && !getSetting(Settings.SkipDashboard)) {
      redirect('/home');
      return;
    }

    if (canIUse(AppFeatures.FormList)) {
      redirect('/forms');
      return;
    }

    redirect('/templates');
  }, []);

  return null;
}
